import * as React from 'react';
import { Button, type ButtonProps } from './button';
import { useLocale } from '@/contexts/LocaleContext';

export type CancelButtonProps = Omit<ButtonProps, 'variant'>;

export const CancelButton = React.forwardRef<HTMLButtonElement, CancelButtonProps>(
  ({ children, type = 'button', size = 'sm', ...props }, ref) => {
    const { t } = useLocale();

    return (
      <Button ref={ref} type={type} variant="ghost" size={size} {...props}>
        {children ?? t('cancel')}
      </Button>
    );
  },
);
CancelButton.displayName = 'CancelButton';
